import { render, staticRenderFns } from "./MentorDetailsModal.vue?vue&type=template&id=00cc3f9c&"
import script from "./MentorDetailsModal.vue?vue&type=script&lang=js&"
export * from "./MentorDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./MentorDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports